import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PageHeader() {
  return <section id="pageheader" className="bg-background relative w-full">
      {}
      <div className="relative bg-gradient-to-b from-[#0F1B2D] to-secondary min-h-[42vh] flex items-center overflow-hidden">
        
        {}
        <div className="absolute inset-0 bg-black/10 pointer-events-none" aria-hidden="true" />

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            {}
            <div className="lg:col-span-7 flex flex-col justify-center">
              
              <Breadcrumb className="mb-6">
                <BreadcrumbList>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to="/" className="text-primary hover:text-primary/80 transition-colors">
                        Home
                      </Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="text-primary/50" />
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to="/MaterialsPage" className="text-primary hover:text-primary/80 transition-colors">
                        Materials
                      </Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="text-primary/50" />
                  <BreadcrumbItem>
                    <BreadcrumbPage className="text-primary/70">
                      Phenolic Engraving Stock
                    </BreadcrumbPage>
                  </BreadcrumbItem>
                </BreadcrumbList>
              </Breadcrumb>

              <span className="text-primary font-semibold tracking-wider uppercase text-sm mb-4 block">
                Material Spec Sheet
              </span>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-white mb-6 leading-tight">
                Phenolic Engraving Material — Specs, Colors & Dielectric Properties
              </h1>

              <p className="text-lg text-gray-300 mb-8 max-w-2xl font-sans leading-relaxed">
                Evermark Industrial Solutions engraves engraving-grade phenolic — a layered thermoset laminate used for control-panel legend plates, nameplates, and MIL-SPEC identification. This is the material reference: thicknesses, stock colors, dielectric and temperature characteristics, and the MIL-SPEC standards phenolic is specified to.
              </p>

              <div className="flex flex-wrap gap-4">
                <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold">
                  <Link to="/ContactPage">Contact Us</Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary/10 font-semibold bg-transparent">
                  
                </Button>
              </div>
            </div>

            {}
            <div className="lg:col-span-5 flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md aspect-[4/3] lg:aspect-square rounded-lg overflow-hidden shadow-2xl border border-white/10">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_engraving_material_layers.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_engraving_material_layers.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_engraving_material_layers.png-wvc-sizes" alt="Phenolic engraving material — two-color engraving-grade phenolic by Evermark Industrial Solutions" className="w-full h-full object-cover" loading="lazy" decoding="async" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}